import React from 'react';
import './ChartTypeOption.scss';

interface ChartTypeOptionProps {
  Icon: any;
  label: string;
  onClick: () => void;
}

export default function ChartTypeOption({ Icon, label, onClick }: ChartTypeOptionProps) {
  return (
    <button
      analytics-id={`chart-type-option-btn-${label.replace(/\s+/g, '-').toLowerCase()}`}
      className='chart-type-option'
      onClick={onClick}
      aria-label={`Select ${label}`}
    >
      <div className='chart-type-option__content'>
        <div className='chart-type-option__icon-container'>
          <Icon />
        </div>
        <span className='chart-type-option__label'>{label}</span>
      </div>
    </button>
  );
}
